"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M9.5 14.1364c.825 0 1.5-.7364 1.5-1.6364S9.5 9.6364 9.5 9.6364 8 11.6 8 12.5c0 .9.675 1.6364 1.5 1.6364zM13 17c.825 0 1.5-.7364 1.5-1.6364S13 12.5 13 12.5s-1.5 1.9636-1.5 2.8636c0 .9.675 1.6364 1.5 1.6364z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0034 4H4.035l.4973 2.7932c.5162.2138 1.0543.2585 1.5602.1323C7.4205 6.594 8.059 5.2468 8.7392 4.186c.7942 1.239 1.5801 2.766 3.2708 2.766 1.6907 0 2.4769-1.527 3.2713-2.7658.6839 1.0668 1.3226 2.402 2.6446 2.7621.5406.1473 1.1072.1 1.6334-.1286L19.9776 4h2.0219l-2.3736 15.9959H4.8517L2.0034 4zM4.917 8.9543l1.61 9.0416h11.3738l1.3379-9.0165a4.3928 4.3928 0 0 1-1.8386-.1015c-.775-.2111-1.501-.6341-2.1305-1.2616-.9202.8737-2.0741 1.3356-3.2597 1.3356-1.1861 0-2.3405-.4623-3.2608-1.3369-.6392.633-1.3793 1.053-2.1724 1.251a4.375 4.375 0 0 1-1.6597.0883z"
  })];
};

exports.default = _default;